import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Link as RouterLink, useNavigate } from "react-router-dom";

import { format } from 'date-fns'

import { SURVEY_TYPE, STATUS } from "data/AdminData"

import { Card, Button, List } from 'semantic-ui-react'


const RowCard = ({ row }) => {
  const navigate = useNavigate()

  return (
    <>
      <Card fluid key={row?.id}>

        <Card.Content>
          <Card.Header>{row?.first_name}{" "}{row?.last_name}</Card.Header>
          <Card.Meta>{row?.email}{" "}{row?.mobiie}</Card.Meta>
       
          <Container>
            <List horizontal>
              {/* sort_order */}
              <List.Item>
                <List.Content>
                <ListContainer>
                   <List.Header>Id (sort_order)</List.Header>
                   {row?.sort_order}
                </ListContainer>
                  </List.Content>
              </List.Item>
              <List.Item>
                <List.Content>
                <ListContainer>
                   <List.Header>Name</List.Header>
                   {row?.name}
                </ListContainer>
                  </List.Content>
              </List.Item>
              <List.Item>
                <List.Content>
                <ListContainer>
                   <List.Header>URL Location (for survey)</List.Header>
                   {row?.url_location}
                </ListContainer>
                  </List.Content>
              </List.Item>
              <List.Item>
                <List.Content>
                <ListContainer>
                   <List.Header>Type</List.Header>
                   {row?.survey_type && SURVEY_TYPE.filter(sy => sy.value === row?.survey_type)?.[0]?.label}
                </ListContainer>
                  </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                <ListContainer>
                   <List.Header>Status</List.Header>
                   {row?.status && STATUS.filter(sy => sy.value === row?.status)?.[0]?.label}
                </ListContainer>
                  </List.Content>
              </List.Item>
              
              <List.Item>
                <List.Content>
                <ListContainer>
                   <List.Header>Created</List.Header>
                   {row?.created_at && format(new Date(row?.created_at), 'dd-MMM-yyyy')}
                </ListContainer>
                 
                </List.Content>
              </List.Item>
              <List.Item>
                <List.Content>
                  <ListContainer>
                     <List.Header>Last Updated</List.Header>
                     {row?.updated_at && format(new Date(row?.updated_at), 'dd-MMM-yyyy')}
                  </ListContainer>
                 
                </List.Content>
              </List.Item>
           
            </List>
          </Container>

          <Card.Description>
            
            <Button floated='right'
              onClick={() => navigate(`/app/questions/details/${row?.id}`)}>
              More Details
            </Button>
          </Card.Description>
        </Card.Content>

      </Card>
    </>
  );
};

RowCard.propTypes = {
  row: PropTypes.object.isRequired,
};

export default RowCard;


const ListContainer = styled.div`
  margin: 0px 25px;
  // padding: 0px 25px;
  // background-color: #dcdcdcdc;
`


const Container = styled.div`
  display: flex;
  margin: 10px 0;
`

